import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import FileAnalysis from "./FileAnalysis/FileAnalysis";
import ScriptAnalysis from "./ScriptAnalysis/ScriptAnalysis";
import UrlAnalysis from "./UrlAnalysis/UrlAnalysis";
import TabButton from "../../../common/TabButton/TabButton";
import InformationPopup from "../../../common/InformationPopup/InformationPopup";
import { informationPopupContent } from "../../../common/InformationPopup/utils/informationPopupUtil";
import TableSpinnerIcon from "../../../Icon-SVG/TableSpinnerIcon";

import { RequestVms } from "../../../../store/actions/dashboardActions";

import "./styles.scss";

// Same short names and order as the OS column of the submissions table
const VM_TAGS = [
  { id: "win7", label: "win7", name: "Windows 7" },
  { id: "win10", label: "win10", name: "Windows 10" },
  { id: "win11", label: "win11", name: "Windows 11" },
  { id: "linux22", label: "linux", name: "Linux" },
  { id: "macos16", label: "macos", name: "MacOS" },
  { id: "andro13", label: "and13", name: "Android 13" },
];

const FileCard = () => {
  const dispatch = useDispatch();
  const [active, setActive] = useState("File Analysis");
  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const vms = useSelector((state) => state.dashboard.vms);
  const vmsLoaded = useSelector((state) => state.dashboard.vmsLoaded);
  const vmsLoading = useSelector((state) => state.dashboard.vmsLoading);

  const availableVmTags = VM_TAGS.filter((vm) => vms.includes(vm.id));
  const hasVms = availableVmTags.length > 0;

  return (
    <div className="file-card">
      {!licenceCheck?.key && (
        <div className="file-card__content--licence">
          <p>Your license is not active, please update your license key.</p>
          <p>
            Click
            <Link to="/system-info" className="file-card__content--licence-font">
              <span> Here </span>
            </Link>
            to update your license key.
          </p>
        </div>
      )}
      <div
        className={`file-card__content border ${
          licenceCheck?.key ? "file-card__content--spudrapis8o" : "file-card__content--frastlci4lw"
        }`}>
        <div className="button-block">
          <TabButton onClick={setActive} title="File Analysis" active={active} />
          <TabButton onClick={setActive} title="Script Analysis" active={active} />
          <TabButton onClick={setActive} title="URL Analysis" active={active} />
        </div>
        <div className="file-card__vms">
          {availableVmTags.map((vm) => (
            <div key={vm.id} className="dashboard__table__groupCounter" title={vm.name}>
              <p>{vm.label}</p>
            </div>
          ))}
          {vmsLoaded && !hasVms ? (
            <div className="dashboard__table__groupCounter file-card__vms__empty">
              <p>No available VM</p>
            </div>
          ) : null}
          <div
            className={`file-card__vms__refresh ${
              vmsLoaded ? `file-card__vms__refresh--${hasVms ? "online" : "offline"}` : ""
            }`}
            title={`${hasVms ? "VMs available" : "No VMs available"}, click to refresh`}
            onClick={() => dispatch(RequestVms())}>
            <TableSpinnerIcon className="file-card__vms__spinner" spin={vmsLoading} />
          </div>
        </div>
        {active === "File Analysis" ? (
          <FileAnalysis />
        ) : active === "Script Analysis" ? (
          <ScriptAnalysis />
        ) : (
          <UrlAnalysis />
        )}
        <span className="file-card__information-popup">
          <InformationPopup
            content={informationPopupContent.fileAnalysis}
            iconWidth={32}
            iconHeight={32}
          />
        </span>
      </div>
    </div>
  );
};

export default FileCard;
